const changeLastToggledElement = (lastElement) =>{
    document.getElementById('empty-sidebar').setAttribute('data-last-open', lastElement);
}

export default changeLastToggledElement;